import { render, staticRenderFns } from "./appoint-people.vue?vue&type=template&id=71fa722b&scoped=true"
import script from "./appoint-people.vue?vue&type=script&lang=js"
export * from "./appoint-people.vue?vue&type=script&lang=js"
import style0 from "./appoint-people.vue?vue&type=style&index=0&id=71fa722b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fa722b",
  null
  
)

export default component.exports